import { avoidAuthToken } from "./../constants";
import * as configUrl from "@frameworks/web/config/domain";
import { footerInvestor } from "./footerLinks";
import staticFooterURL from "@adapters/infrastructures/urlConfig/StaticFooterPages/staticFooter";
import ExchangeHolidayMapper from "@domains/mapper/StaticFooter/IExchangeHoliday";
import { CircularUpdate } from "@domains/mapper/StaticFooter/ICircularUpdatesMapper";
import { getlocationDataMapper } from "@domains/mapper/FooterLinks/IGetLocationDataMapper";
import { FaqUpdateMapper } from "@domains/mapper/StaticFooter/iFaqMapper";
class FooterRepository {
    constructor(http) {
        this.http = http;
    }
    async getMarketStatus() {
        const response = await this.http.request({
            method: "GET",
            url: configUrl.config.jmw + configUrl.config.jmw_content + "marketstatus",
            avoidAuthToken
        });
        if (response) {
            return response.data.lst;
        }
    }
    getFooterPdfLinks() {
        return footerInvestor;
    }
    async getExchangeHolidays() {
        const url = new URL(staticFooterURL.exchangeHoldiday);
        const ExchangeHolidaysData = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            avoidAuthToken,
        });
        // JSON.parse(StaticFooter);
        return ExchangeHolidayMapper(ExchangeHolidaysData);
    }
    async getCircularUpdate(req) {
        const url = new URL(staticFooterURL.circularUpdate);
        url.searchParams.append("fromDate", req.fromDate);
        url.searchParams.append("toDate", req.toDate);
        const circularUpdate = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            avoidAuthToken,
        });
        return CircularUpdate(circularUpdate.data);
    }
    async getlocateusMasterData() {
        const url = new URL(staticFooterURL.locateUsUrl);
        const result = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            avoidAuthToken,
        });
        return getlocationDataMapper(result);
    }
    async getFaqMasterData() {
        const url = new URL(staticFooterURL.faqitems);
        const result = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return FaqUpdateMapper(result);
    }
}
export default FooterRepository;
